import LCLog from '@tencent/lclog-web-mini-sdk';
import { getGuid } from './qbjsapi';

export const lclog = new LCLog({
  id: 'sdk-abdf352d32e8gc9e',
});

export const injectGuid = async () => {
  try {
    const guid = await getGuid();
    if (guid) {
      lclog.setConfig({ uin: guid });
    } else {
      lclog.setConfig({ uin: 'no_guid' });
    }
  } catch (err) {
    lclog.setConfig({ uin: 'no_guid' });
  }
};

